import { render, staticRenderFns } from "./agreeDataIsProof.popup-chunk.vue?vue&type=template&id=94836060"
import script from "./agreeDataIsProof.popup-chunk.vue?vue&type=script&lang=ts"
export * from "./agreeDataIsProof.popup-chunk.vue?vue&type=script&lang=ts"
import style0 from "./agreeDataIsProof.popup-chunk.vue?vue&type=style&index=0&id=94836060&prod&lang=scss"
import style1 from "./agreeDataIsProof.popup-chunk.vue?vue&type=style&index=1&id=94836060&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports